import React, { useEffect } from 'react'
import { Benefits, Comfort, Hero, SoonMobile } from './components'

import About from './components/About/About'
import Offers from './components/Offers/Offers'

function Home() {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
      <Hero />
      <About />
      <Comfort />
      <Offers />
      <Benefits />

      {/* <DriveThru /> */}

      <SoonMobile />
    </>
  )
}

export default Home
